import * as React from "react";
import type { SVGProps } from "react";
const SvgPassport = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9.6 16.8h4.8m-7.6 4.8h10.4a2 2 0 0 0 2-2V4.4a2 2 0 0 0-2-2H6.8a2 2 0 0 0-2 2v15.2a2 2 0 0 0 2 2m7.6-13.2a2.4 2.4 0 1 1-4.8 0 2.4 2.4 0 0 1 4.8 0"
    />
  </svg>
);
export default SvgPassport;
